<div class="grid grid-cols-10 settings-view">
  <nav class="col-span-3">
    <sl-list class="m-3">
      <sl-list-item [active]="location=='profile'" [routerLink]="['profile']">
        <sl-avatar slot="prefix" [initials]="initials"></sl-avatar>
        <sl-label class="mt-2" color="dark">{{name}}</sl-label>
        <sl-label size="small" color="medium">{{email}}</sl-label>
        <sl-icon slot="suffix" name="arrow-right-short" *ngIf="location==='profile'"></sl-icon>
      </sl-list-item>
    </sl-list>
    <sl-menu (slSelect)="location = $any($event).detail.item.value" *ngIf="hasOrganization && isManager">
      <sl-menu-item *ngFor="let item of menuItems" [value]="item.id" [routerLink]="[item.id]"
        [ngClass]="{active:location===item.id}">
        {{item.label}}
        <sl-icon slot="suffix" name="arrow-right-short" *ngIf="location===item.id"></sl-icon>
      </sl-menu-item>
    </sl-menu>
  </nav>
  <div class="col-span-7 outlet">

    <router-outlet></router-outlet>
  </div>
</div>